import { employeeUser } from 'modules/core/store/collections/users'

import { Inconsistencies } from 'modules/attendance/hooks/useShiftInconsistencies'
import { periodEmployee } from 'modules/attendance/lib/periodEmployee'
import type Period from 'modules/attendance/store/models/Period'
import employees from 'modules/employees/store/collections/employees'

export const sortingCustomPeriods = (
  customPeriod: Period,
  sortAttribute: string,
  inconsistencies: Map<string | number, Inconsistencies>
) => {
  switch (sortAttribute) {
    case 'first_name':
      return employeeUser(periodEmployee(customPeriod, employees)).preferredName

    case 'estimated_hours':
      return customPeriod.attributes.estimated_minutes

    case 'worked_hours':
      return customPeriod.attributes.worked_minutes

    case 'hour_balance':
      return parseFloat(customPeriod.attributes.balance_minutes)

    case 'alert_counts':
      const employeeInconsistencies = inconsistencies.get(customPeriod.attributes.employee_id)
      return employeeInconsistencies?.total ?? 0

    default:
      return employeeUser(periodEmployee(customPeriod, employees)).preferredName
  }
}
